module.exports = __webpack_public_path__ + "static/media/estimation-parking.6ef0cf6c.svg";